import { QueryHookOptions, useQuery } from '@apollo/client';
import query from '../../queries/configurations';

interface Params {
  confirmationNum?: string;
  options?: QueryHookOptions;
}

export default function useConfigurations(params: Params = {}) {
  const { confirmationNum, options } = params;
  const { data, ...rest } = useQuery(query, {
    variables: {
      confirmationNum
    },
    ...options
  });

  const configurations = data?.configurations;

  return {
    configurations,
    ...rest
  };
}
